export default "__VITE_ASSET__CNIp$J0p__"